// extracted by mini-css-extract-plugin
module.exports = {"placeholderAlbumArtwork":"AlbumResults_placeholderAlbumArtwork__b3APe"};